import { useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { stripeApi } from '@ctct/infrastructure-layer';
import { Button } from '@ctct/payflow-ui';

export interface StripeElementEditPaymentProps {
  onMount?: () => void | Promise<void>;
  onCancel?: () => void;
  isLoading?: boolean;
}

export const StripeElementEditPayment = ({ onMount, onCancel, isLoading = false }: StripeElementEditPaymentProps) => {
  const { t } = useTranslation();
  const onMountRef = useRef(onMount);

  onMountRef.current = onMount;

  useEffect(() => {
    onMountRef.current?.();
  }, []);

  return (
    <div className="stripe-container">
      {onCancel && (
        <div className="stripe-container__actions">
          <Button
            onClick={onCancel}
            size="medium"
            variant="text"
            data-qe-id="cancel-edit-payment-method"
            busy={isLoading}
            disabled={isLoading}
          >
            {t('payment-methods.cancel')}
          </Button>
        </div>
      )}
      <div id={stripeApi.getStripeElementId()} className="stripe-payment-widget" />
    </div>
  );
};
